var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M5.28571 11H11.7143M5.28571 15.4444H11.7143M13.8571 21H3.14286C1.95939 21 1 20.0051 1 18.7778V3.22222C1 1.99492 1.95939 1 3.14286 1H9.12763C9.41179 1 9.68431 1.11706 9.88524 1.32544L15.6862 7.34123C15.8871 7.5496 16 7.83222 16 8.1269V18.7778C16 20.0051 15.0406 21 13.8571 21Z",
    stroke: "#6B6E7B",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/Document.9486863d4a095b39e8cb9ea5e91055a1.svg";
export { ForwardRef as ReactComponent };